import { Children } from 'react';
import { cx } from '@linaria/atomic';
import type { CommonHTMLAttributes } from '@frontend/types';
import { tabBarStyle } from './styles';

export type TabBarProps = CommonHTMLAttributes & {
  activeTab: string;
  children: Array<JSX.Element | boolean | null>;
};

export const TabBar = ({ activeTab, children, className, style, ...rest }: TabBarProps) => {
  const childArr = Children.toArray(children).filter(Boolean) as JSX.Element[];
  const activeIndex = childArr.findIndex((child) => child.props.id === activeTab);
  const tabWidth = 100 / childArr.length;

  return (
    <div
      className={cx(tabBarStyle, className)}
      style={{
        ['--tab-width' as string]: `${tabWidth}%`,
        ['--tab-underline-x' as string]: `${100 * activeIndex}%`,
        ['--tab-underline-opacity' as string]: activeIndex >= 0 ? 1 : 0,
        ...style,
      }}
      {...rest}
    >
      {children}
    </div>
  );
};
